import { render, staticRenderFns } from "./AnkhList.vue?vue&type=template&id=6e227b1a&scoped=true"
import script from "./AnkhList.vue?vue&type=script&lang=js"
export * from "./AnkhList.vue?vue&type=script&lang=js"
import style0 from "./AnkhList.vue?vue&type=style&index=0&id=6e227b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e227b1a",
  null
  
)

export default component.exports